import './style.scss'
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { AppSpan, CustomContainer } from 'src/style';
import { DropdownOption } from 'src/model';

export const Dropdown: React.FC<any> = ({ 
    trigger, options, leftMargin = 20, 
    rightMargin = 20, topMargin = 20, 
    bottomMargin = 20, width = 19.1,
    onSelect
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [popupStyle, setPopupStyle] = useState<React.CSSProperties>({});
    const triggerRef = useRef<HTMLDivElement>(null);
    const popupRef = useRef<HTMLDivElement>(null);

    const calculatePopupPosition = useCallback(() => {
        if (!triggerRef.current || !popupRef.current) return;
    
        const triggerRect = triggerRef.current.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const popupRect = popupRef.current.getBoundingClientRect();
        const popupWidth = popupRect.width;
        const popupHeight = popupRect.height;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
    
        let topPosition = triggerRect.bottom + scrollTop + topMargin;
        let leftPosition = triggerRect.left + scrollLeft + leftMargin;
    
        // Adjust left position to keep popup fully visible
        if (leftPosition + popupWidth > viewportWidth) {
          leftPosition = viewportWidth - popupWidth - rightMargin;
        }
    
        // Adjust top position to keep popup fully visible
        if (topPosition + popupHeight > viewportHeight) {
          topPosition = viewportHeight - popupHeight - bottomMargin;
        }
    
        setPopupStyle({
          position: 'fixed',
          top: `${topPosition}px`,
          left: `${leftPosition}px`,
          width: `${width}rem`,
          zIndex: 1000,
        });
      }, []);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (popupRef.current && !popupRef.current.contains(event.target as Node) && !triggerRef.current!.contains(event.target as Node)) {
        setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            calculatePopupPosition();
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, calculatePopupPosition]);

    function handleSelect (value: string) {
        if (onSelect) onSelect(value);
        setIsOpen(false)
    }

    return (
        <div style={{ position: 'relative' }}>
        <div ref={triggerRef} onClick={handleToggle} style={{ display: 'inline-block' }}>
            {trigger}
        </div>
        {isOpen && (
            <div 
                ref={popupRef} style={popupStyle} 
                className="dropdown-content-container"
            >
                {
                    options?.map((option: DropdownOption, index: number) => {
                        return (
                            <CustomContainer
                                padding='1' minHeight='3.6'
                                className='dropdown-item-wrapper'
                                key={index}
                                onClick={() => handleSelect(option.value)}
                            >
                                <AppSpan 
                                    fontWeight='500'
                                    cursor='pointer'
                                >
                                    {option.label || option.value}
                                </AppSpan>
                            </CustomContainer>
                        )
                    })
                }
            </div>
        )}
        </div>
    );
};
